export default function (map, modifiedData) {
  const pointLayer = map.getLayer('snow-points-layer');

  if (pointLayer === undefined) {
    map.addSource('snow-points', {
      // GeoJSON Data source used in vector tiles, documented at
      // https://gist.github.com/ryanbaumann/a7d970386ce59d11c16278b90dde094d
      type: 'geojson',
      data: modifiedData,
    });
    map.addLayer({
      id: 'snow-points-layer',
      type: 'circle',
      source: 'snow-points',
      layout: {
        visibility: 'none',
      },
      paint: {
      // See the Mapbox Style Specification for details on data expressions.
      // https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions
      // Get the fill-color from the source 'color' property.
        'circle-color': [
          'let',
          'level',
          ['get', 'snow'],
          ['interpolate', ['linear'], ['var', 'level'],
            0, ['to-color', '#f7f4f9'],
            4, ['to-color', '#e7e1ef'],
            8, ['to-color', '#d4b9da'],
            12, ['to-color', '#c994c7'],
            16, ['to-color', '#df65b0'],
            20, ['to-color', '#e7298a'],
            24, ['to-color', '#ce1256'],
          ],
        ],
        'circle-radius': {
          stops: [[8, 4], [11, 6], [16, 9]],
        },
        'circle-opacity': 0.9,
        'circle-stroke-color': 'white',
        'circle-stroke-width': 1,
        'circle-stroke-opacity': 0.9,
      },
    });
  }
}
